import { UxGameServices } from 'src/app/core/services/ux-game/ux-game-services';
import { GameCompletionData, GameCompletionHandler } from './game-completion-handler';
import { EventName } from 'src/app/core/services/analytics/event-names';
import { scoreSubmitter } from '../common/score-submitter';
import { GameAlert } from '../common/game-alert';

export class PaidCompletionHandler implements GameCompletionHandler {
  constructor(
    private services: UxGameServices,
    private gameAlert: GameAlert,
  ) {}

  public async endGameComplete(
    data: GameCompletionData,
    isComplete: boolean,
    pauseGame: (pause: boolean) => void,
  ): Promise<void> {
    pauseGame(true);

    // TODO: I don't think this is used any more
    const submitScoreMessageKey = '';
    // let submitScoreMessageKey = '';
    // if (this.gameListener instanceof SolitaireUxGameListener) {
    //   submitScoreMessageKey = `submit-score-complete-message-solitaire`;
    // } else if (this.gameListener instanceof BlocksUxGameListener) {
    //   submitScoreMessageKey = isComplete
    //     ? `submit-score-complete-message-blocks`
    //     : `submit-score-not-complete-message-blocks`;
    // }

    await this.submitScore(
      data,
      'game_complete',
      this.services.translocoService.translate('pages.game-component.submit-score-complete-title'),
      this.services.translocoService.translate(`pages.game-component.${submitScoreMessageKey}`),
      this.services.translocoService.translate(
        'pages.game-component.submit-score-complete-subtitle',
        {
          score: data.score,
        },
      ),
    );
  }

  public async endGameUserFinish(
    data: GameCompletionData,
    pauseGame: (pause: boolean) => void,
  ): Promise<void> {
    this.services.analyticsService.log(EventName.ClinchGameFinishClick, { roomId: data.roomId });

    pauseGame(true);

    this.gameAlert?.finish(
      this.services.translocoService.translate('pages.game-component.finish-alert-header'),
      this.services.translocoService.translate('pages.game-component.submit-score-finish-message', {
        score: this.services.themeService.formatNumber(data.score),
      }),
      () => {
        pauseGame(false);
      },
      async (message: string) => {
        await this.submitScore(
          data,
          'game_user_finish',
          message,
          this.services.translocoService.translate(
            'pages.game-component.submit-score-finish-title',
          ),
          this.services.translocoService.translate(
            'pages.game-component.submit-score-finish-subtitle',
            {
              score: this.services.themeService.formatNumber(data.score),
            },
          ),
        );
      },
    );
  }

  public async endGameDeadlineTimeout(
    data: GameCompletionData,
    pauseGame: (pause: boolean) => void,
  ): Promise<void> {
    pauseGame(true);

    await this.submitScore(
      data,
      'game_timeout',
      this.services.translocoService.translate('pages.game-component.submit-score-deadline-title'),
      this.services.translocoService.translate(
        'pages.game-component.submit-score-deadline-message',
      ),
      this.services.translocoService.translate(
        'pages.game-component.submit-score-deadline-subtitle',
        {
          score: data.score,
        },
      ),
    );
  }

  private async submitScore(
    data: GameCompletionData,
    context: string,
    message: string,
    successTitle: string,
    successSubtitle: string,
  ) {
    try {
      // TODO: Please refactor
      await scoreSubmitter(
        context,
        message,
        data.roomId,
        data.moves,
        this.services.loadingController,
        this.services.httpService,
        this.services.analyticsService,
      );
      this.services.analyticsService.log(EventName.ClinchGameSubmitScoreSuccess, {
        roomId: data.roomId,
      });
      this.gameAlert.scoreSubmitted(data.roomId);
    } catch (error) {
      await this.services.analyticsService.handleError(
        error,
        `${EventName.ClinchGameSubmitScoreFail}, room: ${data.roomId}`,
        {
          roomId: data.roomId,
        },
      );
      this.services.analyticsService.log(EventName.ClinchGameSubmitScoreFail, {
        roomId: data.roomId,
      });

      if (data.roundDeadline > Date.now()) {
        const header = this.services.translocoService.translate(
          'pages.game-component.submit-error-header',
        );
        const message = this.services.translocoService.translate(
          'pages.game-component.submit-error-message',
        );
        this.gameAlert.errorFinishWithExit(header, message, async (message: string) => {
          await this.submitScore(data, context, message, successTitle, successSubtitle);
        });
      } else {
        this.gameAlert.scoreNotSubmitted(
          this.services.translocoService.translate(
            'pages.game-component.score-not-submitted-message',
          ),
        );
      }
    }
  }
}
